/**
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 **/

import React, { ReactElement } from 'react';

import { Devices } from '../../utils/constants';
import { BrowserRestrictions, OsRestrictions } from '../../types';
import RestrictionCardDesktop from './restriction-card-desktop';
import RestrictionCardMobile from './restriction-card-mobile';

const { Desktop, Mobile, Tablet } = Devices;

type RestrictionCardProps = {
  className?: string,
  image: { url: string, alt: string }
  device: typeof Desktop | typeof Mobile | typeof Tablet,
  browsers: BrowserRestrictions[],
  os: OsRestrictions[]
};

const defaultProps = {
  className: '',
};

const RestrictionCard: React.FC<RestrictionCardProps> = ({
  className,
  image,
  device,
  browsers = [],
  os = [],
}: RestrictionCardProps): ReactElement => (
  <div className={className}>
    <img className="device-image" src={image.url} alt={image.alt} />
    {device === Desktop ? (
      <RestrictionCardDesktop browsers={browsers} />
    ) : (
      <RestrictionCardMobile device={device} os={os} />
    )}
  </div>
);

RestrictionCard.defaultProps = defaultProps;

export default RestrictionCard;
